import getTodoFolderStore from '../selectors/getTodoFolderStore';
import sortFoldersForDisplay from '../utils/sortFoldersForDisplay';
import TodoFolder from '../store/schema/TodoFolder';
import TodoFolderView from '../store/schema/TodoFolderView';
import { mutator } from 'satcheljs';
import { processLoadedFolders } from '../actions/todoFolderStoreActions';

export const processLoadedFoldersMutator = mutator(processLoadedFolders, actionMessage => {
    const folders: TodoFolder[] = actionMessage.folders;
    if (!folders || folders.length == 0) {
        return;
    }

    const folderStore = getTodoFolderStore();
    folderStore.orderedList = [];
    folderStore.defaultFolderId = null;
    folderStore.folders.clear();

    const sortedFolders = sortFoldersForDisplay(folders);
    sortedFolders.forEach(folder => {
        folderStore.folders.set(folder.Id, folder);
        folderStore.orderedList.push(folder.Id);

        if (folder.IsDefaultFolder) {
            folderStore.defaultFolderId = folder.Id;
        }
    });
});

export { TodoFolderView };
